import { MessageEnvelope, MessagePayload, MessageType } from '@zonofi/common';
import { InternalNoteData } from '@zonofi/seller-rtk-store';

export const convertInternalNoteToMessage = (
  channel: string,
  internalNote: InternalNoteData
): MessageEnvelope => {
  const hasMedia =
    internalNote.message?.media &&
    Array.isArray(internalNote.message?.media) &&
    internalNote.message.media.length > 0;
  const message: MessagePayload = {
    ...internalNote.message,
    type: hasMedia ? MessageType.MEDIA : MessageType.TEXT,
    _id: internalNote.sid || `internal-note-${internalNote.timetoken}`,
    sId: '',
    user: {},
  };
  return {
    channel,
    message,
    isInternalNote: true,
    timetoken: internalNote.timetoken,
    actions: {},
    displayTimetoken: internalNote.timetoken,
  };
};
